import ACCOUNTS_MARKETPLACE_API from 'api/accounts-marketplace/v1'
import { FETCH_CATEGORIES, SET_CATEGORIES, SET_LOADING } from 'modules/AccountsMarketplace/Categories/types'
import { call, put, takeLatest } from 'redux-saga/effects'

function* onLoadData({ payload }) {
  try {
    yield put({ type: SET_LOADING, payload: { loading: true } })

    const { response, error } = yield call(
      ACCOUNTS_MARKETPLACE_API.fetchCategories,
      {
        params: payload,
      },
    )

    if (error) {
      throw error
    }

    yield put({
      type: SET_CATEGORIES,
      payload: response.data,
    })
  } catch (error) {
    console.logXHR(error)
  } finally {
    yield put({ type: SET_LOADING, payload: { loading: false } })
  }
}

export default function* Sagas() {
  yield takeLatest(FETCH_CATEGORIES, onLoadData)
}
